var base = require('settings/payment-method/update-payment-method-stripe');

Vue.component('spark-update-payment-method-stripe', {
    mixins: [base],

    props: [
        'countries'
    ],

    methods: {
        /**
         * Create a Stripe Card Element.
         */
        createCardElement(container){
            var card = this.stripe.elements().create('card', {
                hidePostalCode: true,
                style: {
                    base: {
                        '::placeholder': {
                            color: 'rgba(0,0,0,.50)'
                        },
                        fontFamily: 'Roboto,sans-serif',
                        color: 'rgba(0,0,0,.87)',
                        fontSize: '16px'
                    }
                }
            });

            card.mount(container);

            return card;
        }
    }
});
